import { Component, Input, OnInit } from '@angular/core';
import { UserNotificationService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-module-detail-modal',
    templateUrl: './module-detail-modal.component.html',
    styleUrls: ['./module-detail-modal.component.scss'],
})
export class ModuleDetailModalComponent implements OnInit {
    @Input() moduleId: string;
    @Input() isModuleInReview: boolean = false;

    constructor(
        private activeModal: NgbActiveModal,
        private userNotificationService: UserNotificationService,
    ) {}

    ngOnInit(): void {
        this.userNotificationService.showSpinner();
    }

    close(): void {
        this.activeModal.close();
    }

    handleFinishedLoading(): void {
        this.userNotificationService.hideSpinner();
    }
}
